
const extractAllUnits = (solutions) => {
  let units = []

  for (const solution of solutions || []) {
    for (const building of solution.buildings || []) {
      for (const floor of building.floors || []) {
        for (const wing of floor.wings || []) {
          for (const location of wing.locations || []) {
            units = units.concat(location.units || [])
          }
        }
      }
    }
  }

  return units
}

const enrichUnitsColor = (unitTypesState, solutions) => {
  // debugger;
  // const colorDict = {
  //   lift: 0x676867
  // }
  const mColorDict = {}
  unitTypesState.forEach(ut => {
    // colorDict[ut.id] = parseInt(ut.color.replace(/^#/, ''), 16);
    mColorDict[ut.id] = ut.color;
  })

  const units = extractAllUnits(solutions)
  units.forEach(unit => {
    // unit.hexa_color = colorDict[unit.unit_type]
    unit.color = mColorDict[unit.unit_type]
  })
}

export const enrichSolutions = (unitTypesState, solutionsObj) => {
  enrichUnitsColor(unitTypesState, solutionsObj.solutions)
  return solutionsObj
}